import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { programaApi, programaKeys } from '@/pages/internal/programa/shared/programa-service';

/**
 * The programs ("Arquitetura de Operação") the logged user takes part in.
 * Drives the nav entry: access comes from cohort membership, not the plan.
 * @param {{ enabled?: boolean }} [options]
 */
export function useProgramMembership({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: programaKeys.me(),
    queryFn: programaApi.me,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const programs = useMemo(() => query.data?.programs ?? [], [query.data]);
  /** May the person do `action` in this cohort? Answered by the server (the same rules the API enforces). */
  const can = useCallback(
    (action, cohortId = null) => {
      const program = cohortId ? programs.find((p) => p.cohort?.id === cohortId) : programs[0];
      return Boolean(program?.can?.[action]);
    },
    [programs],
  );
  return {
    ...query,
    programs,
    can,
    isAdmin: Boolean(query.data?.isAdmin),
    // Superadmin only: the account being operated, the default host of a new cohort.
    operatingAccount: query.data?.operatingAccount ?? null,
    isInProgram: Boolean(query.data?.isAdmin) || programs.length > 0,
  };
}
